<template>
  <!--<ins class="adsbygoogle"
  style="display:block"
  data-ad-client="ca-pub-2266518142683202"
  data-ad-slot="9069650242"
  data-ad-format="auto"
  data-full-width-responsive="true"></ins>-->
  <!--<span id="marketing-site-ads" class="marketing-site-ads">
      <div id='div-gpt-ad-1567513322952-0' style='width: 728px; height: 90px;'></div>
  </span>-->

  <div v-if="isProduction" style="background: gray;width: 100%;padding:15px;">
    <span v-if="!clientUserAgent" id="marketing-site-ads" class="marketing-site-ads">
      <div 
        id='div-gpt-ad-1567513322952-0' 
        class='dynamic-marketing-ads' 
        style='width: 728px; height: 90px;background: gray;text-align: center;vertical-align: middle;margin: 0 auto;'>
      </div>
    </span>
    <span v-if="clientUserAgent" id="marketing-site-ads-mobile">
      <div 
        id='div-gpt-ad-1567605286694-0' 
        class='mobile-live-ads' 
        style='width: 234px; height: auto;margin: auto;background: gray;text-align: center;margin: 0 auto;'>
      </div>
    </span>
  </div>
</template>

<script>
import config from "../../config";
import utils from '../../util/';
export default {
  data () { 
    return {
      isLogedIn:false,
      isProduction:true,
      clientUserAgent: config.clientUserAgent,
    };
  },  
  // props:[
  //   "componentKey"
  // ],
  created(){
    const self = this;
    self.isLogedIn = self.$store.state.user;
    self.clientUserAgent = utils.getUserAgent();

    if(process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'development'){
      self.isProduction = false;
    }

    if(self.isLogedIn){
      if(self.clientUserAgent){
          //for mobile
          let el1 = document.getElementById('mobile-div-gpt-ad-script-id');
          if(el1){
            el1.remove();
          }
          let el2 = document.getElementById('mobile-div-gpt-ad-script-tag-id');
          if(el2){
            el2.remove();
          }

          setTimeout(function(){
            let scriptAds = document.createElement("script");
            scriptAds.type = "text/javascript";
            scriptAds.id = 'mobile-div-gpt-ad-script-id';
            let t1 = document.createTextNode(" window.googletag = window.googletag || {cmd: []}; googletag.cmd.push(function() { googletag.defineSlot('/21828552442/DFP_mobile_footer_leaderboard', [300, 100], 'div-gpt-ad-1567605286694-0').addService(googletag.pubads()); googletag.pubads().enableSingleRequest(); googletag.enableServices(); }); ");
            scriptAds.appendChild(t1)            
            document.head.appendChild(scriptAds)

            let scriptAds3 = document.createElement("script");
            scriptAds3.type = "text/javascript";
            scriptAds3.id = 'mobile-div-gpt-ad-script-tag-id';
            let t4 = document.createTextNode(" googletag.cmd.push(function() { googletag.display('div-gpt-ad-1567605286694-0'); }); ");
            scriptAds3.appendChild(t4)
            document.head.appendChild(scriptAds3)
            // googletag.cmd.push(function() { googletag.display('div-gpt-ad-1566303435511-0'); });
          },1000);

      } else {
          //for desktop
          let el1 = document.getElementById('div-gpt-ad-script-id');
          if(el1){
            el1.remove();
          }
          let el2 = document.getElementById('div-gpt-ad-script-tag-id');
          if(el2){
            el2.remove();
          }

          setTimeout(function(){
            let scriptAds1 = document.createElement("script");
            scriptAds1.type = "text/javascript";
            scriptAds1.id = 'div-gpt-ad-script-id';
            let t2 = document.createTextNode(" window.googletag = window.googletag || {cmd: []}; googletag.cmd.push(function() { googletag.defineSlot('/21828552442/loadmax_footer_leaderboard', [728, 90], 'div-gpt-ad-1567513322952-0').addService(googletag.pubads()); googletag.pubads().enableSingleRequest(); googletag.enableServices(); }); ");
            scriptAds1.appendChild(t2)
            document.head.appendChild(scriptAds1)

            let scriptAds2 = document.createElement("script");
            scriptAds2.type = "text/javascript";
            scriptAds2.id = 'div-gpt-ad-script-tag-id';
            let t3 = document.createTextNode(" googletag.cmd.push(function() { googletag.display('div-gpt-ad-1567513322952-0'); }); ");
            scriptAds2.appendChild(t3)
            document.head.appendChild(scriptAds2)
          },1000);
      }                      
    }
  },
  mounted(){
    
    
    // document.getElementById("marketing-site-ads").append("");  
  }
    
};
</script>



// WEBPACK FOOTER //
// src/pages/widgets/GoogleAds.vue